import { Button, Checkbox, FormControlLabel, List, ListItem, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';

function Rationale({ checked, setChecked, customAnswer, setCustomAnswer, setStep, closeView, title }) {
    const handleToggle = (value) => () => {
        checked[value] = !checked[value];
        const newChecked = {...checked};
        setChecked(newChecked);
    }

    function canAdvance() {
        if (checked['inferior-clinical'] || checked['inferior-quality'] || checked['challenging']) {
            return true;
        } else if (customAnswer !== '') {
            return true;
        } else {
            return false;
        }
    }

    function advanceStep() {
        setStep(1);
        window.scrollTo(0, 0);
    }

    function updateCustomAnswer(e) {
        setCustomAnswer(e.target.value);
        setChecked({...checked, 'custom-answer': e.target.value});
    }

    return (
        <Stack spacing={2}>
            <Stack spacing={2}>
                <Typography variant='heavy' sx={{ fontSize: '16px' }}>{title ?? 'Why did you decline this swap?'}</Typography>
                <Typography variant='normal' sx={{ fontSize: '14px', color: '#0000008A', letterSpacing: '0.25px' }}>
                    This information helps optimize surgical supply chain for you and your colleagues. Thank you!
                </Typography>
                <List>
                    <ListItem>
                        <FormControlLabel 
                            control={<Checkbox checked={checked['inferior-clinical']} onChange={handleToggle('inferior-clinical')} />} 
                            label={<Typography variant='normal' fontSize='14px'>Item produces inferior clinical results</Typography>}
                            name='inferior-clinical'
                        />
                    </ListItem>
                    <ListItem>
                        <FormControlLabel 
                            control={<Checkbox checked={checked['inferior-quality']} onChange={handleToggle('inferior-quality')} />} 
                            label={<Typography variant='normal' fontSize='14px'>Item is inferior in quality to what I currently use</Typography>}
                            name='inferior-quality' 
                        />
                    </ListItem>
                    <ListItem>
                        <FormControlLabel 
                            control={<Checkbox checked={checked['challenging']} onChange={handleToggle('challenging')} />} 
                            label={<Typography variant='normal' fontSize='14px'>Item is more technically challenging to use</Typography>}
                            name='challenging'
                        />
                    </ListItem>
                    <ListItem>
                        <TextField 
                            label='Enter custom answer' 
                            multiline 
                            fullWidth
                            rows={3}
                            variant='outlined'
                            value={customAnswer}
                            onChange={(e) => updateCustomAnswer(e)}
                        />
                    </ListItem>
                </List>
            </Stack>
            <Stack spacing={2} alignItems='center'>
                <Button variant='blueContained' disabled={!canAdvance()} onClick={advanceStep}>Submit Feedback</Button>
                <Button variant='text' onClick={closeView}>Back to Swap</Button>
            </Stack>
        </Stack>
    );
}

export default Rationale;
